import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spin } from 'antd';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();
    
    // Verificación del token
    const token = sessionStorage.getItem('accessToken');
    
    // Mostrar loader mientras se verifica
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" tip="Verificando sesión..." />
            </div>
        );
    }
    
    // Si no hay token o usuario, redirigir a login
    if (!token || !user) {
        // (basename del Router quitado tras mover al dominio dedicado optimus.twparts.mx)
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    
    return children;
};

export default ProtectedRoute;